import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  // apiKey: import.meta.env.PUBLIC_FIREBASE_PUBLIC_API_KEY,
  // authDomain: import.meta.env.PUBLIC_FIREBASE_AUTH_DOMAIN,
  // projectId: import.meta.env.PUBLIC_FIREBASE_PROJECT_ID,
  // storageBucket: import.meta.env.PUBLIC_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: import.meta.env.PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  // appId: import.meta.env.PUBLIC_FIREBASE_APP_ID,
  apiKey: "AIzaSyBxzf61PJlF5tJBVZZZD6cJsXqTF_Lalvs",
  authDomain: "liv-cycling.firebaseapp.com",
  projectId: "liv-cycling",
  storageBucket: "liv-cycling.appspot.com",
  messagingSenderId: "527173478622",
  appId: "1:527173478622:web:e96ef065efa0ada280ba4f",
  measurementId: "G-6KFCT9ZZN7"
};
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
// if (process.env.NODE_ENV === "development") {
//   const auth = getAuth();
//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(db, "localhost", 8080);
//   const functions = getFunctions(getApp());
//   const storage = getStorage();
//   connectStorageEmulator(storage, "localhost", 9199);
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }

export { db, storage, auth };